import { lazy, Suspense } from 'react'
import { RouteObject } from 'react-router-dom'
import FundLayout from 'layout/fund/FundLayout'
import DotsLoading from 'components/loadings/dotsLoading'
import ErrorBug from 'components/errors/bugs'

// lazy: keeps recharts out of the main bundle, same as the admin dashboard
const Guarantees = lazy(() => import('./index'))

export const guaranteesRoutes: RouteObject[] = [
    {
        // Mounted bare, this page was the one screen with no phone frame: on
        // a desktop browser, tapping «ضمانت‌های شما» on home jumped from the
        // 30%-wide column to the full window. The frame is the layout's job,
        // so the page sits under one like every other phone-shaped route.
        path: '/guarantees',
        element: <FundLayout helmet="ضمانت‌های من" />,
        errorElement: <ErrorBug />,
        children: [
            {
                index: true,
                element: (
                    <Suspense fallback={<DotsLoading />}>
                        <Guarantees />
                    </Suspense>
                ),
            },
        ],
    },
]
